import { render, staticRenderFns } from "./sensoryCalibrationList.vue?vue&type=template&id=295054a8"
import script from "./sensoryCalibrationList.vue?vue&type=script&lang=js"
export * from "./sensoryCalibrationList.vue?vue&type=script&lang=js"
import style0 from "./sensoryCalibrationList.vue?vue&type=style&index=0&id=295054a8&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('295054a8')) {
      api.createRecord('295054a8', component.options)
    } else {
      api.reload('295054a8', component.options)
    }
    module.hot.accept("./sensoryCalibrationList.vue?vue&type=template&id=295054a8", function () {
      api.rerender('295054a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/sensory/sensory-calibration/sensoryCalibrationList.vue"
export default component.exports